import React from 'react';
import { Tag } from 'antd';
import { resolveDocumentStatusMeta } from '../../utils/documentStatusDisplay';

export type DocumentStatusBadgeProps = {
  status?: string | null;
  className?: string;
};

/**
 * Unified document / lifecycle status badge (DOC-013).
 */
const DocumentStatusBadge: React.FC<DocumentStatusBadgeProps> = ({ status, className }) => {
  const meta = resolveDocumentStatusMeta(status);
  if (meta.label === '—') {
    return <Tag className={className}>—</Tag>;
  }
  return (
    <Tag color={meta.color} className={className}>
      {meta.label}
    </Tag>
  );
};

export default DocumentStatusBadge;
